import React from "react";

type Props = {
    name?: string;
    placeholder?: string | null;
    options: {
        value: string | number;
        label: string
    }[];
    label?: string | null;
    value: number | undefined | string;
    callbackOnChange: (e: any) => void;
    disabledValues?: number[] | string[];
    isRequired?: boolean;
    callbackOnFocus?: () => any; 
    hasError?: boolean;
    errorMessage?: string;
    disabled?: boolean;
}

const Select: React.FC<Props> = ({
    name,
    placeholder,
    options,
    label,
    value,
    callbackOnChange,
    disabledValues = [],
    isRequired = false,
    callbackOnFocus,
    hasError = false,
    errorMessage = '',
    disabled = false
}) => {

    const handleChange = (e: any) => {
        callbackOnChange(e);
    }

    return (
        <div>
            {
                !!label &&
                <label className="font-semibold text-sm text-red uppercase leading-[17px] block mb-[5px]" htmlFor={name}>{label}{isRequired ? ' *' : ''}</label>
            }

            <select disabled={disabled} onFocus={callbackOnFocus} required={isRequired} onChange={handleChange} value={value} className={"block mt-[5px] p-[10px] border border-[#6F6F6F] leading-[18px] rounded-[8px] text-[15px] w-full" + (hasError ? ' border-red' : '')} name={name} id={name}>
                <option value="" disabled>{placeholder}</option>
                {
                    options.length > 0 &&
                    options.map((option, index) => {
                        return (
                            <option
                                key={index}
                                disabled={disabledValues.some(v => v === option.value)}
                                value={option.value}
                            >
                                {option.label}
                            </option>
                        )
                    })
                }
            </select>

            {
                hasError && !!errorMessage &&
                <div className="text-xs text-red font-semibold mt-1">
                    {errorMessage}
                </div>
            }
        </div>
    );
}

export default Select;